import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import { BaseButton } from '@ertelecom/ui-react/components/buttons/baseButton';
import { Container as MainContainer } from '../styled';

export const Container = MainContainer;

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: ${COLORS.black};
    @media(max-width: 985px) {
        flex-derection: column;
        height: auto;
        padding: 130px 0 70px;
    }
    @media(max-width: 720px) {
        padding: 95px 0 40px;
    }
`;

export const Content = styled.div`
    display: block;
    width: 600px;
    @media(max-width: 1550px) {
        width: 450px;
    }
    @media(max-width: 1240px) {
        width: 350px;
    }
    @media(max-width: 985px) {
        width: 100%;
        margin-bottom: 72px;
    }
    @media(max-width: 720px) {
        margin-bottom: 60px;
    }
`;

export const Subtitle = styled.h1`
    ${FONTS.H3};
    color: ${COLORS.white};
    @media(max-width: 1550px) {
        ${FONTS.H4};
    }
    @media(max-width: 1240px) {
        ${FONTS.H4};
    }
    @media(max-width: 985px) {
        ${FONTS.H3};
    }
    @media(max-width: 720px) {
        ${FONTS.H4};
    }
`;

export const Title = styled.p`
    ${FONTS.H1};
    color: ${COLORS.white};
    margin: 14px 0 40px;
    @media(max-width: 1550px) {
        ${FONTS.H2};
    }
    @media(max-width: 1240px) {
        ${FONTS.H3};
        margin: 10px 0 30px;
    }
    @media(max-width: 985px) {
        ${FONTS.H2};
        br {
            display: none;
        }
    }
    @media(max-width: 720px) {
        ${FONTS.H3};
    }
`;

export const Button = styled(BaseButton)`
    width: ${p => p.long ? '320px' : '220px'};
`;

export const FormButton = styled(BaseButton)`
  max-height: 40px;
  margin-left: 20px;
`;

export const Image = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    right: -20px;
    bottom: 0;
    left: auto;
    margin: auto 0;
    width: calc(100vw - ((100vw - 1360px) / 2) - 600px  - 63px);
    align-items: center;
    border-radius: 9px;
    overflow: hidden;
    z-index: 3;
    pointer-events: none;
    img {
        display:block;
        width: 100%;
        pointer-events: auto;
    }
    @media(max-width: 1550px) {
        width: calc(100vw - ((100vw - 1032px) / 2) - 450px  - 63px);
    }
    @media(max-width: 1240px) {
        width: calc(100vw - ((100vw - 803px) / 2) - 350px  - 63px);
    }
    @media(max-width: 985px) {
        position: relative;
        width: calc(700px + 20px + (100% - 700px) / 2);
        right: calc( (100% - 700px) / -2);
    }
    @media(max-width: 720px) {
        width: 100%;
        right: -10px;
    }
`;
